/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';

/**
 * A specialized button component to allow a user to move right in a datepicker
 */
export default class RightButton extends React.Component {
  render() {
    const { onClick, disabled } = this.props;
    return (
      <button
        type="button"
        id="rightArrowButton"
        className="slds-button slds-button--icon-container"
        onClick={onClick}
        disabled={disabled}
      >
        <svg
          aria-hidden="true"
          className="slds-button__icon slds-button__icon--small"
        >
          <use xlinkHref="/assets/icons/utility-sprite/svg/symbols.svg#right" />
        </svg>
      </button>
    );
  }
}
